import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from 'components/Code';
import { Typography } from 'material-ui';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoShortDescription extends Component {

    render() {
        const { code, shortDescription } = this.props;
        return (
            <CodeInfoSection title='Краткое описание товара'>
                {<Typography> <Code code={code} /> - {shortDescription}</Typography>
                }
            </CodeInfoSection>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoShortDescription.js